export default __webpack_public_path__ + "static/media/pop_hazards_path_protection.2a6576ab.svg";